var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSvg193(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3039_9694)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.0188 48.0001C25.4532 48.0001 26.6157 46.8376 26.6157 45.4032V35.6345L27.9938 37.0126C29.0063 38.0251 30.6563 38.0251 31.6688 37.0126C32.6813 36.0001 32.6813 34.3501 31.6688 33.3376L25.8845 27.5626C24.8251 26.5501 23.1563 26.5501 22.0876 27.5626L16.3126 33.3376C15.3001 34.3501 15.3001 36.0001 16.3126 37.0126C17.3251 38.0251 18.9751 38.0251 19.9876 37.0126L21.422 35.5782V45.4032C21.422 46.8376 22.5845 48.0001 24.0188 48.0001Z",
    fill: "#DB2A12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9812 0C22.5468 0 21.3843 1.1625 21.3843 2.59688V12.3656L20.0062 10.9875C18.9937 9.975 17.3437 9.975 16.3312 10.9875C15.3187 12 15.3187 13.65 16.3312 14.6625L22.1155 20.4375C23.1749 21.45 24.8437 21.45 25.9124 20.4375L31.6968 14.6625C32.7093 13.65 32.7093 12 31.6968 10.9875C30.6843 9.975 29.0343 9.975 28.0218 10.9875L26.5874 12.4219V2.59688C26.578 1.1625 25.4155 0 23.9812 0Z",
    fill: "#DB2A12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0001 23.9812C48.0001 22.5468 46.8376 21.3843 45.4032 21.3843H35.6345L37.0126 20.0062C38.0251 18.9937 38.0251 17.3437 37.0126 16.3312C36.0001 15.3187 34.3501 15.3187 33.3376 16.3312L27.5626 22.1155C26.5501 23.1749 26.5501 24.8437 27.5626 25.9124L33.3376 31.6968C34.3501 32.7093 36.0001 32.7093 37.0126 31.6968C38.0251 30.6843 38.0251 29.0343 37.0126 28.0218L35.5782 26.5874H45.4032C46.8376 26.578 48.0001 25.4155 48.0001 23.9812Z",
    fill: "#DB2A12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 24.0188C0 25.4532 1.1625 26.6157 2.59688 26.6157H12.3656L10.9875 27.9938C9.975 29.0063 9.975 30.6563 10.9875 31.6688C12 32.6813 13.65 32.6813 14.6625 31.6688L20.4375 25.8845C21.45 24.8251 21.45 23.1563 20.4375 22.0876L14.6625 16.3126C13.65 15.3001 12 15.3001 10.9875 16.3126C9.975 17.3251 9.975 18.9751 10.9875 19.9876L12.4219 21.422H2.59688C1.1625 21.422 0 22.5845 0 24.0188Z",
    fill: "#DB2A12"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3039_9694"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg193);
export default __webpack_public_path__ + "static/media/svg193.413491fd02165b34ffeedf4f79090f46.svg";
export { ForwardRef as ReactComponent };